import { Grid, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import Box from "ReusableComponents/Box";
import CTAImage from "assets/CTA.png";
import Text from "ReusableComponents/Text";
import FuelType from "Pages/Landing/components/SavingsCalculator/components/FuelType";
import Payload from "./components/Payload";
import Commute from "./components/Commute";
import { COLORS, SIZES } from "theme";
import { Calculations } from "calculations";
import { FORMATTER } from "utils";
import Dropdown from "ReusableComponents/Dropdown";
import { StormCalculation } from "storm.calculation";

const SavingsCalculator = () => {
  const small = useMediaQuery("(max-width: 600px)");

  const [selecetd, setSelected] = useState("");
  const [selectedVehicle, setSelectedVehicle] = useState('');

  const getCheckedValue = (val) => {
    setSelected(val.name);
  };

  const [weeklySavings, setWeeklySavings] = useState(0);
  const [dailySavings, setDailySavings] = useState(0);
  const [yearlySavings, setYearlySavings] = useState(0);
  const [showCalc] = useState(true);

  const getDetails = (item, type, amount) => {
    if (amount) setState({ ...state, [type]: item, price: amount });
    else setState({ ...state, [type]: item });
  };

  const [state, setState] = useState({
    fuel: "diesel",
    dailyCommute: 60,
    monthlyCommute: 1680,
    price: 92,
  });

  const getTotalSavings = (items) => {
    const { daily, weekly, yearly } = items;

    setDailySavings(daily);
    setWeeklySavings(weekly);
    setYearlySavings(yearly);
  };

  return (
    <Grid
      container
      spacing={3}
      style={{
        width: "auto",
        height: small ? "774" : "900px",

        background: COLORS.lightBlack,
        padding: small ? "0px" : "24px 20px",
      }}
    >
      <Grid item xs={12}>
        <Box textAlign="center" display="flex" flexDirection="column">
          <Text
            textColor="white"
            fontWeight="bold"
            fontSize={small ? "20px" : "40px"}
            margin="0px 0"
          >
            Savings Calculator
          </Text>
        </Box>
      </Grid>
      {!small && (
        <Grid item md={6} xs={12} style={{ alignContent: "center" }}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height="100vh"
          >
            <img
              src={
                selectedVehicle === 'StormEV' ? 'https://euler-assets.s3.ap-south-1.amazonaws.com/TR_498x400_without_Shadow_db92314961.webp':"https://euler-assets.s3.ap-south-1.amazonaws.com/dv_side_angle_783f3e6107.webp"
              }
              style={{ width: "70%" }}
              alt="cta"
            />
          </Box>
        </Grid>
      )}
      <Grid item xs={12} md={6}>
        <Box
          padding={small ? "0px" : "20px"}
          style={{
            backgroundColor: "#202124",
            borderRadius: "8px",
            color: "black",
          }}
        >
          <Dropdown title="Select Vehicle" small={small} setSelectedVehicle={setSelectedVehicle}/>

          <Payload getDetails={getDetails} small={small} selectedVehicle={selectedVehicle}/>
          <Commute vehicle={selectedVehicle} getDetails={getDetails} small={small} />
          <FuelType
            getValue={getCheckedValue}
            getDetails={getDetails}
            selecetd={selecetd}
            small={small}
          />
          <Box
            b={!small && "1px solid #393939"}
            marginTop={small ? "10px" : "10px"}
            marginBottom={small ? "10px" : "0px"}
            padding={small && "0px 10px"}
          >
            {showCalc && (
              <Box diplay="none">
                {selectedVehicle === 'StormEV' ?
                <StormCalculation
                  dailyTravelKm={state.dailyCommute}
                  getTotalSavings={getTotalSavings}
                  fuelCost={state.price}
                /> : <Calculations
                  dailyTravelKm={state.dailyCommute}
                  getTotalSavings={getTotalSavings}
                  fuelCost={state.price}
                />}
              </Box>
            )}

            <Box
              background="#9CCDFB"
              display="flex"
              justifyContent="space-between"
              padding="24px"
            >
              <Box display="flex" flexDirection="column">
                <Text fontSize={small ? SIZES.twelve : "17px"} margin={0}>
                  Daily
                </Text>
                <Text
                  fontSize={small ? SIZES.twelve : "20px"}
                  fontWeight="bold"
                  margin={0}
                >
                  {FORMATTER.format(dailySavings >= 0 ? dailySavings : 0)}
                </Text>
              </Box>
              <Box display="flex" flexDirection="column">
                <Text fontSize={small ? SIZES.twelve : "17px"} margin={0}>
                  Weekly
                </Text>
                <Text
                  fontSize={small ? SIZES.twelve : "20px"}
                  fontWeight="bold"
                  margin={0}
                >
                  {FORMATTER.format(weeklySavings >= 0 ? weeklySavings : 0)}
                </Text>
              </Box>
              <Box display="flex" flexDirection="column">
                <Text fontSize={small ? SIZES.twelve : "17px"} margin={0}>
                  Yearly
                </Text>
                <Text
                  fontSize={small ? SIZES.twelve : "20px"}
                  fontWeight="bold"
                  margin={0}
                >
                  {FORMATTER.format(yearlySavings >= 0 ? yearlySavings : 0)}
                </Text>
              </Box>
            </Box>
          </Box>
          {!small && (
            <Box marginTop="0px" padding={"0px 10px"}>
              <Text textColor="white" fontSize={"16px"}>
                Disclaimer: The savings shown are approximate and as per
                internal calculations. The actual values will vary depending on
                the use of your vehicle. T&C apply*
              </Text>
            </Box>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default SavingsCalculator;
